import React from 'react';
import * as aserver from '../../APIClient';
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import Button from '@material-ui/core/Button';
import TableRow from "@material-ui/core/TableRow";
import Checkbox from "@material-ui/core/Checkbox";
import Pagination from "././pagination";
import PropTypes from "prop-types";
import Tooltip from "@material-ui/core/Tooltip";
import * as utils from "../../Utilities"
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Modal from '../comps/modal';
import AlertModal from "../comps/alertModal";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import dotIcon from '../images/Dots horizontal.png'

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    color: 'white !important',
  },
}))(Tooltip);

const drawerWidth = 240;

const styles = theme => ({
    root: {
      width: "100%",
      marginTop: theme.spacing(3),
      display: 'flex',
    },
    table: {
      minWidth: 1020
    },
    tableWrapper: {
      overflowX: "auto"
    },

      toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
      },
      toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
      },
      appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      },
      appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
      menuButton: {
        marginRight: 36,
      },
      menuButtonHidden: {
        display: 'none',
      },
      title: {
        flexGrow: 1,
      },
      drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
      drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      },
      appBarSpacer: theme.mixins.toolbar,
      content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'hidden',
      },
      container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
      },
      paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
      },
      fixedHeight: {
        height: 'auto',
      },
  });

  class AllRowSelect extends React.Component {
    constructor(props) {
      super(props);
      this.myRef = React.createRef()  
    }
    render() {
      const {
        onSelectAllClick,
        numSelected,
        rowCount
      } = this.props;
  
      return (
            <TableCell padding="checkbox">
              <Checkbox
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={numSelected === rowCount}
                onChange={onSelectAllClick}
              />
            </TableCell>
      );
    }
  }
  
  AllRowSelect.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    rowCount: PropTypes.number.isRequired
  };

class AephoriaTable extends React.Component {
    constructor(props) {
        super(props);
        let record = {};
        this.props.displayFields.forEach(field => record[field] = '');
        this.state = {
            route: this.props.route,
            selected: [],
            disabledButtonCaptions: [],
            disabledButtonTooltips: {},
            userToken: "",
            clientId:"",
            items:[],
            itemsFiltered: [],
            pageOfItems:[],
            search:"",
            guestUUIDs: [],
            userIDS:[],
            userTokens:[],
            clientUUID: "",
            showStopFilter: false,
            numberOfItemsFiltered:0,
            selectedFilterButton: "",
            devTest: false,
            sortBy: "tokenCreatedAt",
            filterByColumn: "tokenCreatedAt",
            sortAsc: true,
            currentSort: "desc",
            confirmationModal: false,
            confirmationHeading: "",
            confirmationModalText: "",
            confirmationFunction: null,
            selectedRecordUUID: null,
            members:[],
            openAlertModal: false,
            failModalText: [],
            successModalText: "",
            alertModalTitle: "",
            alertMessage: "",
            showAllButtons: false,
            anchorEl: null,
            clientUUIDArray:[]
        };
    }


    refreshTable = async()=> {
        this.setupButtonState(0, [])
        let result;
        if ((this.props.route)&&(this.props.route.callback)) {
          result = await this.props.route.callback();
        } else {
          result = await aserver.get(this.props.route);
        }
        if (this.props.massageData) {
          this.props.massageData(result.data);
        }
        var filterByColumn;
        if(result.data.find(obj => {
          return obj.clientName
        })){
          filterByColumn = "tokenCreatedAt"
          this.setState({
           sortBy:"tokenCreatedAt",
           filterByColumn:"tokenCreatedAt"
         })
        }
        else if(result.data.find(obj => {
          return obj.name
        })) {
          filterByColumn = "createdAt"
          this.setState({
            sortBy:"createdAt",
            filterByColumn:"createdAt"
          })
        }
          else{
            filterByColumn = "updatedAt"
            this.setState({
              sortBy:"updatedAt",
              filterByColumn:"updatedAt"
            })
        }
        this.setState({
            isLoaded: true,
            items: result.data,
            itemsFiltered:result.data.sort(this.sortDataBy(filterByColumn)),
            numberOfItemsFiltered: result.data.length
        });
        if(localStorage.getItem("functionFilterId")){
          this.setState({
            selectedFilterButton: this.props.activeFilterButton
          })
          this.filterRecords(this.props.activeFilterButton)
        }
        if(this.state.selectedFilterButton){
          this.filterRecords('filter', {
            selectedFilterButton:this.state.selectedFilterButton,
            showStopFilter:true,
          })
        }else if(this.state.searchTerm){
          this.filterRecords('search', {searchTerm: this.state.searchTerm,showStopFilter:true});
        }
    }

    searchSpace = event => {
      const inputValue = event.currentTarget.value.toString().toLowerCase();
      this.filterRecords('search', {searchTerm: inputValue,showStopFilter:true});
    }
  
    changeFilter=(event)=>{
      this.filterRecords('filter', {
        selectedFilterButton:event,
        showStopFilter:true,
      });
    }
  
    filterRecords=(filterType, newFilterState)=>{
  
      // get items from state
      const {items, sortBy} = this.state;
      // get filterdropdown and search terms from state for filtering now
      var {searchTerm, selectedFilterButton} = this.state;
      // set state for future events
      this.setState(newFilterState);
  
      if (filterType==='search') {
        // get the current search term
        searchTerm = newFilterState.searchTerm;
      }
      if (filterType==='filter') {
        // get the current filterdropdown details
        selectedFilterButton = newFilterState.selectedFilterButton;
      }
      // set up filterdropdown
      let filterButtons = utils.filterButtons 
      let findButtonToFilterWith = filterButtons.find(e => e.id === selectedFilterButton)
  
      // 1) filter by search term
      let searchFilteredItems;
      if (!searchTerm) {
        searchFilteredItems = items.sort(this.sortDataBy(sortBy));
      } else {
        searchFilteredItems = items.sort(this.sortDataBy(sortBy)).filter(item=> {
          for (let field of this.props.displayFields) {
            let fieldName = field.dataField;
            if (fieldName === 'assessmentTypeDecorated') {
              fieldName = 'decoratedAssessmentTypeText';
            }
            if (fieldName === 'infoTile'|| fieldName === 'mobileInfoTile') {
              fieldName = 'infoTileSearchableText';
            }
            if ((item[fieldName] + '').toLowerCase().includes(searchTerm)) {
              return true;
            }
          }
          return(false)
        })
      }
  
      // 2) now filter by the filterdropdown
      let filteredItems;
      if (!findButtonToFilterWith) {
        filteredItems = searchFilteredItems;
      } else {
        filteredItems = searchFilteredItems.filter(function(item) {
          return findButtonToFilterWith.filterFunction(item)
        })
      }
  
      this.setState({
        itemsFiltered: filteredItems,
        selectedFilterButtonText: filterButtons.caption,
        numberOfItemsFiltered: filteredItems.length,
      });
  
    }
  
    returnUnfilteredItems=()=>{
      localStorage.removeItem("functionFilterId")
      document.getElementById('search').value = ''
      this.setState({
        itemsFiltered: this.state.items,
        selectedFilterButton: "",
        showStopFilter:false,
        numberOfItemsFiltered: this.state.items.length,
        searchTerm:""
       });
    }

    onChangePage = pageOfItems => {
      document.getElementById('containerDiv').scrollIntoView();     
       this.setState({
        pageOfItems: pageOfItems
      });
    };

    setupButtonState = (numRecordsSelected, selectedUUIDs = []) => {
      let disabledButtonCaptions = [];
      let disabledButtonTooltips = {};

      for (let tf of this.props.tableFunctions) {
        let disabled = true;
        let disabledReason = null;

        if (numRecordsSelected >= tf.minRecordsRequired) {
          disabled = false;
        }
        if ((numRecordsSelected > tf.minRecordsRequired) && (numRecordsSelected > tf.maxRecordsRequired)) {
          disabled = true;
        }

        if (disabled) {
          if (tf.minRecordsRequired > 0 && numRecordsSelected < tf.minRecordsRequired) {
            disabledReason = tf.minRecordsRequired === 1
              ? 'Select at least 1 record to use this action.'
              : `Select at least ${tf.minRecordsRequired} records to use this action.`;
          } else if (tf.maxRecordsRequired && numRecordsSelected > tf.maxRecordsRequired) {
            disabledReason = tf.maxRecordsRequired === 1
              ? 'Select only 1 record to use this action.'
              : `Select no more than ${tf.maxRecordsRequired} records to use this action.`;
          }
          disabledButtonCaptions.push(tf.caption);
          if (disabledReason) disabledButtonTooltips[tf.caption] = disabledReason;
        }

        if (!disabled && tf.caption === 'Delete' && this.props.deleteConfig && selectedUUIDs.length > 0) {
          const { checkForReportRequested, disabledDeleteCheck } = this.props.deleteConfig;
          if (checkForReportRequested || disabledDeleteCheck) {
            const selectedRecords = selectedUUIDs
              .map(id => this.state.itemsFiltered.find(r => r.uuid === id.toString()))
              .filter(Boolean);
            const isBlocked = disabledDeleteCheck
              ? selectedRecords.some(disabledDeleteCheck)
              : selectedRecords.some(r => r.reportRequested);
            if (isBlocked) {
              disabledButtonCaptions.push(tf.caption);
              disabledButtonTooltips[tf.caption] = this.props.deleteConfig.disabledDeleteTooltip || 'Cannot delete: a report has already been requested or generated for one or more selected records.';
            }
          }
        }

        if (!disabled && tf.disabledCheck && selectedUUIDs.length > 0) {
          const selectedRecords = selectedUUIDs
            .map(id => this.state.itemsFiltered.find(r => r.uuid === id.toString()))
            .filter(Boolean);
          if (selectedRecords.some(tf.disabledCheck)) {
            disabledButtonCaptions.push(tf.caption);
            if (tf.disabledTooltip) disabledButtonTooltips[tf.caption] = tf.disabledTooltip;
          }
        }
      }

      this.setState({
        disabledButtonCaptions,
        disabledButtonTooltips,
      });
    }

    openAlertModal=(title, message)=>{
      this.setState({
        alertModalTitle: title,
        alertMessage: message,
        openAlertModal: true,
      });
    }

    closeModal = () => {
      this.setState({
        confirmationModal:false,
        openAlertModal: false,
        failModalText:[],
        successModalText: ""
        });
    }

    openDeleteConfirmationModal = (selectedRecords) => {

      const recordsToDelete = [];
      let hasRecordFromAnotherCoach = false;
      let hasRecordGivenToAnotherCoach =false;
    
      for (let id of selectedRecords) {
        const findRecordToDelete = this.state.itemsFiltered.find(({ uuid }) => uuid === id.toString());
    
        if (findRecordToDelete) {
          recordsToDelete.push(this.props.deleteConfig.displayCallback(findRecordToDelete));
    
          if (findRecordToDelete.fromAnotherCoach) {
            hasRecordFromAnotherCoach = true;
          }

          if (findRecordToDelete.scoGivenTo ||findRecordToDelete.scoReceivedFrom) {
            hasRecordGivenToAnotherCoach = true;
          }
        }
      }

      if (hasRecordFromAnotherCoach) {
        this.openAlertModal("Please note", "Your selection includes records that were given to you by another coach. Please amend your selection and try again.")
        return;
      }

      if (hasRecordGivenToAnotherCoach) {
        this.openAlertModal("Please note", "Your selection includes records that you gave to another coach. Please remove those records from your selection and try again, or revoke SCO for the applicable records and try again.")
        return;
      }

      this.setState({
        selectedRecordsToDelete: selectedRecords,
        members: recordsToDelete,
        confirmationModal: true,
        confirmationHeading: "Confirmation",
        confirmationModalText: `Are you sure you wish to remove?`,
        confirmationFunction: (e) => this.deleteMultipleRecords(e),
      });
    };

    deleteMultipleRecords = async () => {
      const { selectedRecordsToDelete,itemsFiltered } = this.state;
      this.setState({confirmationModal: false})
      let success = []
      let failureMessages = []
      for (let selectedUUID of selectedRecordsToDelete){
        let findRecordToDelete = itemsFiltered.find(({ uuid }) => uuid === selectedUUID.toString());
        if (this.props.deleteConfig.pluralDisplayName === "Teams") {
          const { name, reportRequested, scoGivenTo, scoReceivedFrom } = findRecordToDelete;
          if (reportRequested) {
              failureMessages.push(`The report for team ${name} has already been requested or generated - cannot delete.`);
              continue;
          }
        }
        let deleted = await aserver.del(`${this.props.deleteConfig.endpoint}/${selectedUUID}`);
        if (deleted.status === 200) {
          success.push("Member successfuly removed")
        }else{
          failureMessages.push(deleted.data.error.info)
        }
      }
      if (success.length > 0 && failureMessages) {
        if (this.props.updateLayout) {
          this.props.updateLayout();
        }
        this.refreshTable()
        this.UnCheckAll()
        this.closeModal()
      }
      if (failureMessages.length > 0) {
        let text = success.length>0 && failureMessages.length>0?"Not all records could be deleted":"Failed"
        this.setState({
          successModalText: `${success.length} of ${selectedRecordsToDelete.length} removed.`,
          failModalText: failureMessages,
        });
        this.openAlertModal(text)
      } else {
        if (typeof this.props.onDelete === 'function') {
          this.props.onDelete();
        }
      }
    };
    
    handleButtonClick = (tf) => {
      const {selected, userTokens, clientId, guestUUIDs, clientUUIDArray, userIDS} = this.state;
      this.setState({ 
        anchorEl: null,
        anchorEl2:null,
        anchorEl3:null  
      });
      if (tf.caption === 'Delete') {
        if(tf.disableDeleteButton){
          this.openAlertModal("Please note", "You cannot edit membership of a team for which a report has already been requested or issued. Rather make a duplicate of this team, edit the members, and then request a new report for the duplicated team.")
          return
        }
        if (this.state.selected.length >= tf.minRecordsRequired) {
          this.openDeleteConfirmationModal(selected);
        }
      } else {
        tf.ourownonclick(selected, userTokens, clientId, guestUUIDs, clientUUIDArray, userIDS);
      }
    }
   
    handleSelectAllClick = (event, checked) => {
      if (checked) {
        let selectedGuestUUIDS = this.state.itemsFiltered.map(n => n.guestUUID);
        this.setState({guestUUIDs: selectedGuestUUIDS})

        let selectedUUIDS = this.state.itemsFiltered.map(n => n.uuid);
        this.setState({selected: selectedUUIDS})
        this.props.selectedData(selectedUUIDS.length)

        if (this.props.onSelectionChanged) {
          this.props.onSelectionChanged(selectedUUIDS);
        }

        let numRecordsSelected = selectedUUIDS.length;
        this.setupButtonState(numRecordsSelected, selectedUUIDS)

        if(this.state.devTest){
          console.log("===============================All Records Selected==================================")
          console.log("All Guest UUUIDs selected", selectedGuestUUIDS)
          console.log("All Client UUIDs selected", selectedUUIDS)
        }

      }else{
        this.setState({
          selected:[],
          guestUUIDs: [],
          userIDS: [],
          userTokens: [],
        });
        let numRecordsSelected = 0;
        this.setupButtonState(numRecordsSelected, [])

        if (this.props.onSelectionChanged) {
          this.props.onSelectionChanged([]);
        }

        if(this.state.devTest){
          console.log("===============================All Records Unchecked by All Records button==================================")
          console.log("All User IDs unselected", this.state.selected)
          console.log("All Guest UUUIDs unselected", this.state.guestUUIDs)
        }
      }
    
    };

    handleClick = (event,id, userToken, ClientId, guestUUID, clientUUID, userId) => {
        const { selected, guestUUIDs, userIDS, userTokens, clientUUIDArray} = this.state;

        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
            selected.slice(0, selectedIndex),
            selected.slice(selectedIndex + 1)
          );
        }
        this.setState({ selected: newSelected });
        this.props.selectedData(newSelected.length)


        if (this.props.onSelectionChanged) {
          this.props.onSelectionChanged(newSelected);
        }
        let numRecordsSelected = newSelected.length;
        this.setupButtonState(numRecordsSelected, newSelected);

        /////==================================


        const selectedIndexs = guestUUIDs.indexOf(guestUUID);
        let newSelectedId = [];

        if (selectedIndexs === -1) {
          newSelectedId = newSelectedId.concat(guestUUIDs, guestUUID);
        } else if (selectedIndexs === 0) {
          newSelectedId = newSelectedId.concat(guestUUIDs.slice(1));
        } else if (selectedIndexs === guestUUIDs.length - 1) {
          newSelectedId = newSelectedId.concat(guestUUIDs.slice(0, -1));
        } else if (selectedIndexs > 0) {
          newSelectedId = newSelectedId.concat(
            guestUUIDs.slice(0, selectedIndexs),
            guestUUIDs.slice(selectedIndexs + 1)
          );
        }

        this.setState({ guestUUIDs: newSelectedId });

        //=========================================

        const selectedIDs = userIDS.indexOf(userId);
        let SelectedUserIDs = [];

        if (selectedIDs === -1) {
          SelectedUserIDs = SelectedUserIDs.concat(userIDS, userId);
        } else if (selectedIDs === 0) {
          SelectedUserIDs = SelectedUserIDs.concat(userIDS.slice(1));
        } else if (selectedIDs === userIDS.length - 1) {
          SelectedUserIDs = SelectedUserIDs.concat(userIDS.slice(0, -1));
        } else if (selectedIDs > 0) {
          SelectedUserIDs = SelectedUserIDs.concat(
            userIDS.slice(0, selectedIDs),
            userIDS.slice(selectedIDs + 1)
          );
        }
        this.setState({ userIDS: SelectedUserIDs });

        //==========================================


        /// ========================================
        const selectedAssessmentTokens = userTokens.indexOf(userToken);
        let newTokensSelected = [];

        if (selectedAssessmentTokens === -1) {
          newTokensSelected = newTokensSelected.concat(userTokens, userToken);
        } else if (selectedAssessmentTokens === 0) {
          newTokensSelected = newTokensSelected.concat(userTokens.slice(1));
        } else if (selectedAssessmentTokens === userTokens.length - 1) {
          newTokensSelected = newTokensSelected.concat(userTokens.slice(0, -1));
        } else if (selectedAssessmentTokens > 0) {
          newTokensSelected = newTokensSelected.concat(
            userTokens.slice(0, selectedAssessmentTokens),
            userTokens.slice(selectedAssessmentTokens + 1)
          );
        }

        this.setState({ userTokens: newTokensSelected });

        const selectedClientUUID = clientUUIDArray.indexOf(clientUUID);
        let newSelectedClientUUIDArray = [];

        if (selectedClientUUID === -1) {
          newSelectedClientUUIDArray = newSelectedClientUUIDArray.concat(clientUUIDArray, clientUUID);
        } else if (selectedClientUUID === 0) {
          newSelectedClientUUIDArray = newSelectedClientUUIDArray.concat(clientUUIDArray.slice(1));
        } else if (selectedClientUUID === clientUUIDArray.length - 1) {
          newSelectedClientUUIDArray = newSelectedClientUUIDArray.concat(clientUUIDArray.slice(0, -1));
        } else if (selectedClientUUID > 0) {
          newSelectedClientUUIDArray = newSelectedClientUUIDArray.concat(
            clientUUIDArray.slice(0, selectedClientUUID),
            clientUUIDArray.slice(selectedClientUUID + 1)
          );
        }

        this.setState({ clientUUIDArray: newSelectedClientUUIDArray });

        this.setState({
          clientId: ClientId,
        });
        
        if(this.state.devTest){
          console.log("===============================Single Selected Record ==================================")
          console.log("User Token selected", newTokensSelected)
          console.log("User ID selected", SelectedUserIDs)
          console.log("Guest UUUID selected", newSelectedId)
          console.log("Client UUID selected", clientUUID)
          console.log("ID selected", newSelected)
        }
    };

    isSelected = id => this.state.selected.indexOf(id) !== -1;

    UnCheckAll = () =>{
      let numRecordsSelected = 0;
      this.setupButtonState(numRecordsSelected, [])
      this.setState({
        selected: [] ,
        guestUUIDs: [],
        userIDS: [],
        userTokens:[],
        clientUUIDArray:[],
      });

      if (this.props.onSelectionChanged) {
        this.props.onSelectionChanged([]);
      }

      if(this.state.devTest){
        console.log("===============================Uncheck All Records==================================")
        console.log("Unchecked ID array", this.state.selected)
        console.log("Unchecked Guest UUUID array", this.state.guestUUIDs)
        console.log("Unchecked User ID array", this.state.userIDS)
      }
    }

   sortDataBy = (sortBy, currentSort) => (a, b) => {
    let aValue, bValue;

    
    const propertyMap = {
      assessmentTypeDecorated: ['assessmentType'],
      infoTile: ['fullname', 'displayName'],
      teamLeaderToggle: ['isTeamLeader']
    };

    if (propertyMap.hasOwnProperty(sortBy)) {
      const keys = propertyMap[sortBy];
      aValue = keys.map(k => a[k]).find(v => v !== undefined);
      bValue = keys.map(k => b[k]).find(v => v !== undefined);
    } else {
      aValue = a[sortBy];
      bValue = b[sortBy];
    }

    
    let Asc = "asc";

    if (sortBy === "teamLeaderToggle") {
      if (currentSort === Asc) {
        return bValue - aValue;
      } else {
        return aValue - bValue; 
      }
    }

    if(sortBy === "tokenCount" || sortBy === "memberCount"|| sortBy === "teamLeaderToggle"){
      // number sort
      // direction must be included
      if(currentSort === Asc)
      return aValue - bValue;
      else
      return bValue - aValue;

    } else {
      if (!aValue) { // empty string
        return 1; // or 0... not sure
      }
      if (!bValue) { // empty string
        return -1; // or 0... not sure
      }

      if (sortBy==='scoreIMF') { // this is very specific assessment code in aephoriaTable.
        aValue = a['finalTPR']*100+a['aim'];
        bValue = b['finalTPR']*100+b['aim'];
        if (currentSort === Asc) { // or "desc" not sure
          return(aValue-bValue)
        } else {
          return(bValue-aValue)
        }
      }
    
      // use case insenstive comparison function (something like localecompare?)
      if (currentSort === Asc) {
        return aValue.toLowerCase().localeCompare(bValue.toLowerCase());
      } else {
        return bValue.toLowerCase().localeCompare(aValue.toLowerCase());
      }
    }
   };

   sort = (e, sortBy) =>{
    const { currentSort } = this.state;
		let nextSort;

    e.preventDefault()
		if(currentSort === 'desc')
     nextSort = 'asc';
		else 
     nextSort = 'desc';
    if(sortBy === "trackingStatus"){
      sortBy = this.state.sortBy
    }
    const {itemsFiltered} = this.state;
    const copyOfArray = [...itemsFiltered];
    copyOfArray.sort(this.sortDataBy(sortBy, nextSort))

    this.setState({ 
      sortBy: sortBy,
      itemsFiltered: copyOfArray,
      sortAsc: this.state.sortBy === sortBy ? !this.state.sortAsc : true,
			currentSort: nextSort
    });
   }

   
   showAdd = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

   showMore = (event) => {
    this.setState({
      anchorEl2: event.currentTarget,
    });
  };

  showMobileDropdown = (event) => {
    this.setState({
      anchorEl3: event.currentTarget,
    });
  };

  closeDropdown = () => {
    this.setState({
      anchorEl: null,
      anchorEl2: null,
      anchorEl3: null,
    });
  };

  escFunction = (event) => {
    if (event.keyCode === 27) {
      this.closeModal()
    }
  }


    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, false);
        if (this.props&&this.props.route&&this.props.route.callback) {
          this.setState({
            mountedWithCallback: true
          });
        }
        this.refreshTable();  
    }

    componentDidUpdate() {
      if (this.state.route!==this.props.route) {
        if (this.props.route)
          if ((this.props.route.callback)&&(this.state.routeHadCallbackBefore))
            return;
        if (this.state.mountedWithCallback)
          return;
        this.setState({
            route: this.props.route,
            routeHadCallbackBefore: this.props.route.callback
        });
        this.refreshTable();
      }
    }

    generateButton(tableFunction, className) {
      const isDisabled = this.state.disabledButtonCaptions.includes(tableFunction.caption);
      const tooltip = isDisabled
        ? (this.state.disabledButtonTooltips[tableFunction.caption] || tableFunction.tooltipText || '')
        : (tableFunction.tooltipText || '');
      return (
        <CustomTooltip title={tooltip} key={tableFunction.caption}>
          <span>
            <Button className={className} disabled={isDisabled} onClick={() => this.handleButtonClick(tableFunction)} variant="contained" color="primary">
              {typeof tableFunction.icon === 'string'
                ? <img src={tableFunction.icon} className="buttonIcon" alt='icon'/>
                : tableFunction.icon} {tableFunction.caption}
            </Button>
          </span>
        </CustomTooltip>
      );
    }

    generateDropDownButtons(tableFunction, className) {
      const isDisabled = this.state.disabledButtonCaptions.includes(tableFunction.caption);
      const tooltip = isDisabled
        ? (this.state.disabledButtonTooltips[tableFunction.caption] || tableFunction.tooltipText || '')
        : (tableFunction.tooltipText || '');
      return (
        <CustomTooltip title={tooltip} key={tableFunction.caption}>
          <span>
            <MenuItem className={className} disabled={isDisabled} onClick={() => this.handleButtonClick(tableFunction)} variant="contained" color="primary">{tableFunction.caption}</MenuItem>
          </span>
        </CustomTooltip>
      );
    }
          

    render() {
        const columnsToDisplay = [...this.props.displayFields];
        const { itemsFiltered, pageOfItems, selected, items, numberOfItemsFiltered, selectedFilterButton, sortBy} = this.state;

        const { tableFunctions } = this.props;
        const frequentlyUsedButtons = tableFunctions.filter(
          (tableFunction) => tableFunction.frequentlyUsed === true
        );

        const addButtons = tableFunctions.filter(
          (tableFunction) => tableFunction.addDropdown === true
        );

        const otherButtons = tableFunctions.filter(
          (tableFunction) => tableFunction.frequentlyUsed === false
        );

        const mainMobileButtons = tableFunctions.filter(
          (tableFunction) => tableFunction.mainMobileButton === true
        );
        const mobileDropdown = tableFunctions.filter(
          (tableFunction) => tableFunction.mainMobileButton === false
        );
        return (
          <>
          <div className='tableButtons'>
            
            {addButtons.length>0 &&(
              <Button variant="contained" color="primary" onClick={this.showAdd}>
                Add <img src={dotIcon} className="buttonIcon dotIcon" alt='icon'/>
              </Button>
            )}
                  <Menu
                     elevation={0}
                     getContentAnchorEl={null}
                     anchorOrigin={{
                       vertical: 'bottom',
                       horizontal: 'left',
                     }}
                     transformOrigin={{
                       vertical: 'top',
                       horizontal: 'left',
                     }}
                    anchorEl={this.state.anchorEl}
                    keepMounted
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.closeDropdown}
                  >
                    <div>
                      {addButtons.map(tableFunction => this.generateDropDownButtons(tableFunction, 'inDropDown'))}
                    </div>
                  </Menu>

              {frequentlyUsedButtons.map(tableFunction => this.generateButton(tableFunction,'showOnDesktop'))}


              {otherButtons.length>0&&(
                <Button variant="contained" color="primary" className='showOnDesktop' onClick={this.showMore}>
                  More <img src={dotIcon} className="buttonIcon dotIcon" alt='icon'/>
                </Button>
              )}
                  <Menu
                     elevation={0}
                     getContentAnchorEl={null}
                     anchorOrigin={{
                       vertical: 'bottom',
                       horizontal: 'left',
                     }}
                     transformOrigin={{
                       vertical: 'top',
                       horizontal: 'left',
                     }}
                    anchorEl={this.state.anchorEl2}
                    keepMounted
                    open={Boolean(this.state.anchorEl2)}
                    onClose={this.closeDropdown}
                  >
                    <div>
                      {otherButtons.map(tableFunction => this.generateDropDownButtons(tableFunction, 'inDropDown'))}
                    </div>
                  </Menu>

            {/* ============================Mobile buttons ======================*/}
            
            {mainMobileButtons.map(tableFunction => this.generateButton(tableFunction,'showOnMobile'))}
            {mobileDropdown.length > 0 && (
              <Button variant="contained" color="primary" className='showOnMobile' onClick={this.showMobileDropdown}>
                More <img src={dotIcon} className="buttonIcon dotIcon" alt='icon'/>
              </Button>
            )}
                  <Menu
                    elevation={0}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    anchorEl={this.state.anchorEl3}
                    keepMounted
                    open={Boolean(this.state.anchorEl3)}
                    onClose={this.closeDropdown}
                  >
                    <div>
                      {mobileDropdown.map(tableFunction => this.generateDropDownButtons(tableFunction, 'inDropDown'))}
                    </div>
                  </Menu>
          </div>

              <div className='filterAndSearchDiv'>
                <div>
                  <input 
                      type="text" 
                      className="form-control form-control-lg" 
                      id="search"
                      placeholder="Search" 
                      value={this.state.value}
                      onChange={this.searchSpace}
                  />
                </div>
                <div style={{display: this.props.filterButtons.length>1?"block":"none", "width":"15%"}} className='styled-select'>
                  <select
                    value={selectedFilterButton}
                    onChange={(e) => this.changeFilter(e.target.value)}
                  >
                    <option value="" disabled>
                      Select a filter
                    </option>
                    {this.props.filterButtons.map((button) => (
                      <option key={button.caption} value={button.id}>
                        {button.caption}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="filterInfoDiv">
                <div className='recordsTextDiv'>
                    
                    <div className='filteredRecordsTextDiv'><span style={{display:this.state.showStopFilter?"inline":"none"}}>Filtered</span> <span>{numberOfItemsFiltered} of {items.length} records</span></div>
                    <div className="selectedLength">
                      <Button  variant="contained" color="primary" style={{display:this.state.showStopFilter?"block":"none"}} onClick={()=>this.returnUnfilteredItems()}>x</Button>
                    </div>
                    </div>
                <div className='recordsTextDiv'>
                  <div className="selectedLength" style={{display:selected.length > 0 ?"inline":"none"}}>
                        {selected.length} selected
                  </div>
                  <div className="selectedLength" style={{display:selected.length > 0 ?"inline":"none"}}>   
                      <Button variant="contained" color="primary" onClick={()=>this.UnCheckAll()}>Uncheck All</Button>
                  </div>
                </div>
              </div>
            

        <div className='tablePagDiv last-child'>
            <Table id="containerDiv">
                <TableHead >
                        <TableRow>
                        <AllRowSelect
                          numSelected={selected.length}
                          selectedId={selected.id}
                          onSelectAllClick={this.handleSelectAllClick}
                          rowCount={itemsFiltered.length}
                        />
                        {columnsToDisplay.map(field => 
                            (<TableCell key={field.dataField}>          
                              <TableSortLabel
                                active={sortBy===field.dataField}
                                onClick={'trackingStatus'=== field.dataField||'reportSuppliedAt'===field.dataField ? null: (e)=>this.sort(e, field.dataField, true)}
                                hideSortIcon={('trackingStatus'=== field.dataField|| 'reportSuppliedAt' ===field.dataField)}
                                direction={this.state.currentSort}
                              >{field.caption} {field.icon}
                              </TableSortLabel>
                            </TableCell>)
                          )}
                        </TableRow>
                </TableHead>
                <TableBody >
                    {pageOfItems.map(n => {
                      const isSelected = this.isSelected(n.uuid);
                      return (
                        <TableRow  
                        role="checkbox"
                        aria-checked={isSelected}
                        tabIndex={-1}
                        key={n.uuid+(n.id?n.id:n.guestId)}
                        selected={isSelected}
                        >
                            <TableCell>
                              <Checkbox checked={isSelected} onClick={event => this.handleClick(event, n.uuid, n.userToken, n.ClientId ,n.guestUUID, n.clientUUID, n.id)}/>
                            </TableCell > 
                             {columnsToDisplay.map(field => 
                            (<TableCell  
                              style={{color: n.coachWrappedUp===1 ? "grey": "#00447D"}}
                              onClick={n[field.dataField]===n.teamLeaderToggle ||n[field.dataField]===n.reportSuppliedAt?null: event => this.handleClick(event, n.uuid, n.userToken, n.ClientId ,n.guestUUID, n.clientUUID, n.id)} 
                              key={n.id+field.dataField}
                              className={field.dataField === 'mobileInfoTile' ? 'mobile-info-cell' : ''}
                              id={field.dataField === "miniAssessmentInfoTile"? "mini-info-cell":""}
                              >
                              {field.dataField === 'tokenCreatedAt' || field.dataField === 'createdAt' ? n[field.dataField].slice(0, 10) : n[field.dataField]}
                            </TableCell>)
                            )}
                        </TableRow>
                      );
                    })}
                </TableBody>
            </Table>      

          <Modal isOpen={this.state.confirmationModal} onClose={() => this.closeModal()}>
            <h3>{this.state.confirmationHeading}</h3>
            <p>{this.state.confirmationModalText}</p>
            <ul className="confirmationModalList">{this.state.members.map((displayName,i) => {return (<li key={i}>{displayName} </li>)})}</ul>
            <Button variant="contained" color="primary" type="submit" onClick={() => this.state.confirmationFunction(true)}>Yes</Button>
            <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>No</Button>
            {this.state.showModalCancelButton ? <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>Cancel</Button> : null}
          </Modal>

          {/* ====================== AlertModal ========================*/}
          <AlertModal
            message={this.state.alertMessage}
            modalTitle={this.state.alertModalTitle}
            isOpen={this.state.openAlertModal}
            showClose={this.closeModal}
          >
            <br style={{ display: this.state.successModalText ? "visible" : "none" }}></br>
            <p style={{ display: this.state.successModalText ? "visible" : "none" }} className="delineatedHeading">{this.state.successModalText}</p>
            <div style={{ display: this.state.failModalText.length > 0 ? "visible" : "none" }} className="miniTable">
              <table>
                <tbody >
                  {this.state.failModalText.map(info => {
                    return (
                      <p>{info}</p>
                    )
                  })}
                </tbody>
              </table>
            </div>  
          </AlertModal>
        </div>
        <Pagination
                pageSize={50}
                items={itemsFiltered}
                onChangePage={this.onChangePage}
              />
        </>
        );
    }
}

export default withStyles(styles)(AephoriaTable);